import styled from 'styled-components';

export default styled.div`
  padding: 1rem;
  background: #F7F7F7;
`;
